import { Injectable } from '@angular/core';
import { FacadeService } from './facade.service';
import { StreamResource } from '../../models/stream-resource';

@Injectable({
  providedIn: 'root'
})
export class StreamService {
  public data = new StreamResource();
  public error = new StreamResource();
  public contact = new StreamResource();
  public order = new StreamResource();

  constructor(private facadeService: FacadeService) { }

  getData() {
    this.data.request(() => this.facadeService.getData());
  }

  getFirstLoginError() {
    this.error.request(() => this.facadeService.getFirstLoginError());
  }

  getContact() {
    this.contact.request(() => this.facadeService.getContact());
  }

  getOrder() {
    this.order.request(() => this.facadeService.getOrder());
  }

  public setWizard(model: string, title?: string, isMigratedUser: boolean = false) {
    const wizardData = {
      model: model,
      title: title ? title : null,
      isMigratedUser: isMigratedUser
    }
    this.data.update(wizardData);
  }

  public setFirstLoginError(error: any) {
    this.error.update(error);
  }

  public setContact(contact: any) {
    this.contact.update(contact);
  }

  public setOrder(order: any) {
    this.order.update(order);
  }
}